export default __webpack_public_path__ + "assets/images/a078bd73f5a474a4a1969e87d3be62bc.svg";